import blenderIcon from "../../../../../../../../assets/icons/train-types/blender.png";
import centrifugeIcon from "../../../../../../../../assets/icons/train-types/centrifuge.png";
import conveyorIcon from "../../../../../../../../assets/icons/train-types/conveyor.png";
import conveyorBeltIcon from "../../../../../../../../assets/icons/train-types/conveyor-belt.png";
import coolingTowerIcon from "../../../../../../../../assets/icons/train-types/cooling-tower.png";
import craneIcon from "../../../../../../../../assets/icons/train-types/crane.png";
import crusherIcon from "../../../../../../../../assets/icons/train-types/crusher.png";
import crystallizerIcon from "../../../../../../../../assets/icons/train-types/crystallizer.png";
import defaultTrainIcon from "../../../../../../../../assets/icons/train-types/default-train.png";
import dissolverIcon from "../../../../../../../../assets/icons/train-types/dissolver.png";
import drillIcon from "../../../../../../../../assets/icons/train-types/drill.png";
import drumIcon from "../../../../../../../../assets/icons/train-types/drum.png";
import dryerCoolerIcon from "../../../../../../../../assets/icons/train-types/dryer-cooler.png";
import elevatorIcon from "../../../../../../../../assets/icons/train-types/elevator.png";
import fanIcon from "../../../../../../../../assets/icons/train-types/fan.png";
import fanImpellerIcon from "../../../../../../../../assets/icons/train-types/fan-impeller.png";
import feederIcon from "../../../../../../../../assets/icons/train-types/feeder.png";
import flotationIcon from "../../../../../../../../assets/icons/train-types/flotation.png";
import furnaceIcon from "../../../../../../../../assets/icons/train-types/furnace.png";
import gantryCraneIcon from "../../../../../../../../assets/icons/train-types/gantry-crane.png";
import millIcon from "../../../../../../../../assets/icons/train-types/mill.png";
import mixerIcon from "../../../../../../../../assets/icons/train-types/mixer.png";
import mixerDualIcon from "../../../../../../../../assets/icons/train-types/mixer-dual.png";
import motorIcon from "../../../../../../../../assets/icons/train-types/motor.png";
import pumpIcon from "../../../../../../../../assets/icons/train-types/pump.png";
import rollerPressIcon from "../../../../../../../../assets/icons/train-types/roller-press.png";
import screenIcon from "../../../../../../../../assets/icons/train-types/screen.png";
import separatorIcon from "../../../../../../../../assets/icons/train-types/separator.png";
import skpuIcon from "../../../../../../../../assets/icons/train-types/skpu.png";
import thickenerIcon from "../../../../../../../../assets/icons/train-types/thickener.png";
import turbineIcon from "../../../../../../../../assets/icons/train-types/turbine.png";
import vacuumFilterIcon from "../../../../../../../../assets/icons/train-types/vacuum-filter.png";

export const CONVEYOR_ICON_SRC = conveyorIcon;
export const DEFAULT_TRAIN_ICON_SRC = defaultTrainIcon;
export const DISSOLVER_ICON_SRC = dissolverIcon;
export const ELEVATOR_ICON_SRC = elevatorIcon;
export const MIXER_DUAL_ICON_SRC = mixerDualIcon;
export const BLENDER_ICON_SRC = blenderIcon;
export const CENTRIFUGE_ICON_SRC = centrifugeIcon;
export const CRANE_ICON_SRC = craneIcon;
export const CRUSHER_ICON_SRC = crusherIcon;
export const SCREEN_ICON_SRC = screenIcon;
export const VACUUM_FILTER_ICON_SRC = vacuumFilterIcon;

export const WIDE_TRAIN_ICON_SRCS = new Set<string>([
  blenderIcon,
  conveyorIcon,
  conveyorBeltIcon,
  dryerCoolerIcon,
  feederIcon,
  mixerDualIcon,
  motorIcon,
  rollerPressIcon,
  skpuIcon,
  vacuumFilterIcon,
]);

export const SYSTEM_TRAIN_TYPE_ICONS: Record<number, string> = {
  1: pumpIcon,
  2: fanIcon,
  3: DEFAULT_TRAIN_ICON_SRC,
  4: turbineIcon,
  5: motorIcon,
  6: DEFAULT_TRAIN_ICON_SRC,
  7: DEFAULT_TRAIN_ICON_SRC,
  8: drillIcon,
  9: DEFAULT_TRAIN_ICON_SRC,
  10: DEFAULT_TRAIN_ICON_SRC,
  11: mixerIcon,
  12: DEFAULT_TRAIN_ICON_SRC,
  13: DEFAULT_TRAIN_ICON_SRC,
};

const CUSTOM_TYPE_ICON_KEYWORDS: Array<{ keywords: string[]; icon: string }> = [
  { keywords: ["торкрет", "shotcrete"], icon: DEFAULT_TRAIN_ICON_SRC },
  { keywords: ["обезопаш", "scaler"], icon: DEFAULT_TRAIN_ICON_SRC },
  { keywords: ["зарядн", "зарядная", "charging machine", "charging"], icon: DEFAULT_TRAIN_ICON_SRC },
  { keywords: ["автосамосвал", "самосвал", "dump truck", "dumptruck"], icon: DEFAULT_TRAIN_ICON_SRC },
  {
    keywords: ["пдм", "погрузочно-доставоч", "погрузочно доставоч", "lhd", "load haul"],
    icon: DEFAULT_TRAIN_ICON_SRC,
  },
  { keywords: ["сбу", "буров", "drill"], icon: drillIcon },
  { keywords: ["миксер", "mixer"], icon: mixerIcon },
  { keywords: ["мешалк", "agitator"], icon: mixerDualIcon },
  { keywords: ["смесител", "blender"], icon: blenderIcon },
  { keywords: ["редуктор", "gearbox", "reducer"], icon: DEFAULT_TRAIN_ICON_SRC },
  { keywords: ["турбин", "гту", "turbine"], icon: turbineIcon },
  {
    keywords: ["электродвигател", "электропривод", "электродвигатель", "motor", "электродвиг"],
    icon: motorIcon,
  },
  { keywords: ["конвейер", "конвеер", "conveyor"], icon: conveyorIcon },
  { keywords: ["ленточн", "belt conveyor"], icon: conveyorBeltIcon },
  { keywords: ["мельниц", "mill"], icon: millIcon },
  { keywords: ["дробил", "crusher", "crush"], icon: crusherIcon },
  { keywords: ["насос", "pump", "вакуум-насос", "вакуум насос"], icon: pumpIcon },
  { keywords: ["вентилятор", "ventilyator", "fan"], icon: fanIcon },
  { keywords: ["крыльчатк", "impeller"], icon: fanImpellerIcon },
  { keywords: ["грохот", "screen", "виброгрохот"], icon: screenIcon },
  { keywords: ["питател", "дозатор", "feeder", "doser"], icon: feederIcon },
  { keywords: ["печь", "печи", "furnace", "обжиг"], icon: furnaceIcon },
  { keywords: ["барабан", "drum"], icon: drumIcon },
  { keywords: ["центрифуг", "centrifug"], icon: centrifugeIcon },
  { keywords: ["элеватор", "elevator"], icon: elevatorIcon },
  { keywords: ["флото", "flotation"], icon: flotationIcon },
  { keywords: ["градирн", "cooling tower", "cooling-tower"], icon: coolingTowerIcon },
  { keywords: ["кристаллизат", "crystalliz"], icon: crystallizerIcon },
  { keywords: ["валков", "валковый пресс", "roller press"], icon: rollerPressIcon },
  { keywords: ["растворител", "dissolv"], icon: dissolverIcon },
  { keywords: ["сепаратор", "separator"], icon: separatorIcon },
  { keywords: ["сгустител", "thickener"], icon: thickenerIcon },
  { keywords: ["скпу", "skpu", "skpy"], icon: skpuIcon },
  { keywords: ["сушилка", "охладител", "dryer", "cooler"], icon: dryerCoolerIcon },
  {
    keywords: ["вакуум-фильтр", "вакуум фильтр", "вакуумный фильтр", "vacuum filter", "vakym"],
    icon: vacuumFilterIcon,
  },
  { keywords: ["портальн", "gantry"], icon: gantryCraneIcon },
  { keywords: ["кратцер", "кран", "crane"], icon: craneIcon },
];

const CUSTOM_TRAIN_TYPE = 14;

export const DEFAULT_MODE_BORDER_COLOR = "#363846";

const TRAIN_TYPE_ICON_SRCS = Array.from(
  new Set([
    DEFAULT_TRAIN_ICON_SRC,
    ...Object.values(SYSTEM_TRAIN_TYPE_ICONS),
    ...CUSTOM_TYPE_ICON_KEYWORDS.map(item => item.icon),
  ]),
);

let preloadPromise: Promise<void> | null = null;

export const preloadTrainTypeIcons = (): Promise<void> => {
  if (preloadPromise) {
    return preloadPromise;
  }

  preloadPromise = Promise.all(
    TRAIN_TYPE_ICON_SRCS.map(
      src =>
        new Promise<void>(resolve => {
          const image = new Image();
          image.onload = () => resolve();
          image.onerror = () => resolve();
          image.src = src;
        }),
    ),
  ).then(() => undefined);

  return preloadPromise;
};

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const textIncludesKeyword = (text: string, keyword: string): boolean => {
  if (keyword.length <= 4) {
    return new RegExp(`(^|[^a-zа-яё0-9])${escapeRegExp(keyword)}([^a-zа-яё0-9]|$)`, "i").test(text);
  }
  return text.includes(keyword);
};

const resolveIconByKeywords = (...textParts: Array<string | null | undefined>): string | null => {
  const normalized = textParts.filter(Boolean).join(" ").toLowerCase();
  if (!normalized) {
    return null;
  }

  for (const { keywords, icon } of CUSTOM_TYPE_ICON_KEYWORDS) {
    if (keywords.some(keyword => textIncludesKeyword(normalized, keyword))) {
      return icon;
    }
  }

  return null;
};

export const resolveTrainTypeIconSrc = (
  trainType?: number | null,
  customTypeTitle?: string | null,
  trainName?: string | null,
  trainInstanceNumber?: string | null,
  description?: string | null,
): string => {
  const isCustomOrUnknown = trainType === CUSTOM_TRAIN_TYPE || trainType == null || trainType === 0;

  if (!isCustomOrUnknown && typeof trainType === "number" && SYSTEM_TRAIN_TYPE_ICONS[trainType]) {
    return SYSTEM_TRAIN_TYPE_ICONS[trainType];
  }

  return (
    resolveIconByKeywords(customTypeTitle, trainName, trainInstanceNumber) ??
    resolveIconByKeywords(description) ??
    DEFAULT_TRAIN_ICON_SRC
  );
};
